import { Component } from '@angular/core';

export class Pendiente { 
    public asunto:string = undefined;
    public creador:string = undefined;
    public departamento: string = undefined;
    public notas:any = undefined;
    public vencimiento:any = undefined;
    public responsable:string = undefined;
    public finalizado:boolean = false;
    public confirmado:boolean = false;

    // Constructor para generar un Idioma
    constructor(){
        
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/models/pendiente.ts